module.exports = __webpack_public_path__ + "static/media/Fee Structure M.Tech.6c410e00.pdf";